module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uploader-list"
  }, [_vm._t("default", [_c('ul', _vm._l((_vm.fileList), function(file) {
    return _c('li', {
      key: file.id
    }, [_c('uploader-file', {
      attrs: {
        "file": file,
        "list": true
      }
    })], 1)
  }))], {
    fileList: _vm.fileList
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-851c8c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list.vue
// module id = 77
// module chunks = 0